export default [
  {
    id: "power-menu",
    title: "PowerMenu",
    hero_images: [
      {
        url: "/images/projects/power-menu-featured.jpg",
        name: "Image #1"
      }
    ],
    introduction:
      "PowerMenu is a tiny but powerful application Tum wrote back in 1998 that adds “Always On Top”, “Transparency” and “Minimize To Tray” to the windows control menu. It’s a popular free tool in use on millions of computers world-wide.",
    externalLink: "https://www.abstractpath.com/powermenu",
    year: "1998",
    internal: true
  },
  {
    id: "p++",
    title: "P++",
    hero_images: [
      {
        url: "/images/projects/p++-featured.jpg",
        name: "Image #1"
      }
    ],
    introduction:
      "P++ is a language based on PL/0, heavily borrowing from C and Haskell. Tum (King Street's Founder) wrote the compiler and interpreter for P++ at University in 2000 as part of his 2nd-year programming languages paper. We've uploaded the code here, hoping it helps people learn and teach compiler construction.",
    externalLink: "https://github.com/tumtumtum/pplusplus",
    year: "2000",
    internal: true
  },
  {
    id: "vncx",
    title: "VNCX",
    hero_images: [
      {
        url: "/images/projects/vncx-featured.jpg",
        name: "Image #1"
      }
    ],
    introduction:
      "VNCX is an ActiveX control for adding VNC client capabilities to any Windows based application that supports ActiveX. It’s written in ATL (no dependencies on MFC) and distributed as a single file (VNCX.dll). It’s a popular free tool in use on millions of computers world-wide. ",
    externalLink: "https://www.abstractpath.com/vncx/",
    year: "2013",
    internal: true
  },
  {
    id: "streaming-kit",
    title: "Streaming Kit",
    hero_images: [
      {
        url: "/images/projects/streaming-featured.jpg",
        name: "Image #1"
      }
    ],
    introduction:
      "Streaming Kit is an audio playback and streaming library for iOS and Mac OSX. It’s the only streaming and playback library to support simple gapless playback between audio files of differing formats. It features a clean and simple object-oriented API and easy to read source code. ",
    externalLink: "https://github.com/tumtumtum/StreamingKit",
    year: "2012",
    internal: true
  },
  {
    id: "shaolinq",
    title: "Shaolinq",
    homepage_image: {
      url: "/images/projects/shaolinq-carouselb.jpg"
    },
    images: [
      {
        url: "/images/projects/shaolinq-featured.jpg",
        name: "Image #1"
      }
    ],
    hero_images: [
      {
        url: "/images/projects/shoalinq-featured.jpg",
        name: "Image #1"
      }
    ],
    introduction:
      "Shaolinq is a powerful ORM and LINQ provider for C# and .NET. It’s a thoughtful and fast alternative to LINQ to SQL and the Entity Framework, and supports SQLite, MySQL, PostgreSQL and Microsoft SQL Server among others. We worked hard to build a system that is as fast as using direct SQL statements. ",
    externalLink: "https://shaolinq.com",
    year: "2007",
    internal: true
  }
];
